/* que botones de metodos de pago mostrar */
import { useState, useEffect } from 'react';

export const usePaymentMethods = (mediosPago, eventoId) => {
  const [medioPago, setMedioPago] = useState('');
  const [multiplesMetodosPago, setMultiplesMetodosPago] = useState(false);

  const mostrarBotonQR = (pasarela) => {
    if (!mediosPago) return false;
    switch (pasarela) {
      case 'pvs':
        return mediosPago.pvs && (mediosPago.pvs_tipo === 'QR' || mediosPago.pvs_tipo === 'AMBOS');
      case 'clickmacro':
        return mediosPago.click_macro && (mediosPago.click_macro_tipo === 'QR' || mediosPago.click_macro_tipo === 'AMBOS');
      case 'pagotic':
        return mediosPago.pagotic && (mediosPago.pagotic_tipo === 'QR' || mediosPago.pagotic_tipo === 'AMBOS');
      default:
        return false;
    }
  };

  const mostrarBotonLink = (pasarela) => {
    if (!mediosPago) return false;
    switch (pasarela) {
      case 'pvs':
        return mediosPago.pvs && (mediosPago.pvs_tipo === 'LINK' || mediosPago.pvs_tipo === 'AMBOS');
      case 'clickmacro':
        return mediosPago.click_macro && (mediosPago.click_macro_tipo === 'LINK' || mediosPago.click_macro_tipo === 'AMBOS');
      case 'pagotic':
        return mediosPago.pagotic && (mediosPago.pagotic_tipo === 'LINK' || mediosPago.pagotic_tipo === 'AMBOS');
      default:
        return false;
    }
  };

  useEffect(() => {
    if (mediosPago) {
      const metodosDisponibles = [
        mediosPago.mercado_pago && 'mercadopago',
        mostrarBotonLink('pagotic') && 'pagotic',
        mostrarBotonLink('pvs') && 'pvs-link',
        mostrarBotonQR('pvs') && 'pvs-qr',
        mostrarBotonQR('clickmacro') && 'clickmacro-qr',
        mostrarBotonLink('clickmacro') && 'clickmacro-link'
      ].filter(Boolean);

      setMultiplesMetodosPago(metodosDisponibles.length > 1);

      if (metodosDisponibles.length === 1) {
        setMedioPago(metodosDisponibles[0]);
      } else if (metodosDisponibles.length > 1) {
        setMedioPago('');
      }
    }
  }, [mediosPago, eventoId]);

  return {
    medioPago,
    setMedioPago,
    multiplesMetodosPago,
    mostrarBotonQR,
    mostrarBotonLink
  };
};